import { BuilderActionInput } from "@src/types.generated";
import {
  getCourseHomeScreenId,
  getPromptScreenId,
} from "@src/features/libraryItem/course/hooks/useCourseScreensAtom";

const HOME_SCREEN_ACTION_KEYS = new Set([
  "setCourseNameAction",
  "setCourseDescriptionAction",
  "setCourseCoverImageAction",
]);

export const targetScreenIdFromAction = (
  payload: BuilderActionInput | null | undefined,
): string | null => {
  const courseAction = payload?.courseBuilderAction;
  if (!courseAction) return null;

  const addedPromptUuid = courseAction.addPromptAction?.prompt?.uuid;
  if (addedPromptUuid) return getPromptScreenId(addedPromptUuid);

  for (const [key, value] of Object.entries(courseAction)) {
    if (key === "removePromptAction" || !value) continue;
    if (HOME_SCREEN_ACTION_KEYS.has(key)) return getCourseHomeScreenId();
    if (
      typeof value === "object" &&
      "promptUuid" in value &&
      typeof value.promptUuid === "string"
    ) {
      return getPromptScreenId(value.promptUuid);
    }
  }
  return null;
};
